module.exports = __webpack_public_path__ + "static/logo-49a20ebc8ff29378df8a9afd5f7c1cf4.svg";